<template>
  <div class="d-flex flex-column flex h100">
    <navbar></navbar>
    <div class="app" style="overflow: hidden;">
      <div id="content" class="app-content box-shadow-3 scroll-x">
        <!-- Optional navbar at top of page -->
        <div class="navbar navbar-light bg-white b-b">
          <div class="navbar-breadcrumbs flex">
            <a v-if="!loading" class="text-muted" :href="`/#/class/${clazz.id}`">{{ clazz.name }}</a>
            <i v-if="!loading" class="far fa-fw fa-angle-right text-muted" />
            <a
              v-if="!loading"
              class="text-muted"
              :href="`/#/class/${clazz.id}/assessment/${assessment.id}`"
            >{{ assessment.name }}</a>
            <i v-if="!loading" class="far fa-fw fa-angle-right text-muted" />
            <span v-if="!loading">{{ delivery.name }}</span>
            <i v-if="!loading" class="far fa-fw fa-angle-right text-muted" />
            <span v-if="!loading">Responses</span>
            <span v-if="loading">
              <loading type="inline-header" />
            </span>
          </div>
          <a
            v-if="clazz"
            class="btn-nav-topright b-l ml-0"
            :href="'/#/class/' + classID + '/assessment/' + assessmentID"
          >
            <div>
              <i class="fas fa-arrow-alt-left fa-fw" />
              Back
            </div>
          </a>
          <a class="btn-nav-topright b-l ml-0" href="/#/landing">
            <div>
              <i class="fas fa-th-large fa-fw" />
              Home
            </div>
          </a>
        </div>

        <div class="content-main">
          <div class="padding" v-if="!loading">
            <div class="p-0 scroll-y">
              <div class="container-fluid">
                <div class="row">
                  <!-- Student Column -->
                  <div class="col col-sm-6 align-self-stretch">
                    <div class="box m-0 h100 b-b">
                      <div class="box-header">
                        <h2>Students</h2>
                      </div>
                      <div class="box-body">
                        <p class="m-0">
                          Drag a student to the files that they are associated with. Hover
                          over a student to see their files.
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Media Column -->
                  <div class="col col-sm-6 align-self-stretch scroll-y">
                    <div class="box m-0 h100 b-b">
                      <div class="box-header d-flex flex-row">
                        <h2 class="flex">Files</h2>
                        <button v-if="!saving && !dirty" class="btn btn-secondary" disabled>Save</button>
                        <button v-if="!saving && dirty" @click="save()" class="btn primary">Save</button>
                        <button v-if="saving" class="btn disabled primary">
                          Saving
                          <span
                            v-if="completeFiles <= totalFiles"
                          >{{ completeFiles }}/{{ totalFiles }}</span>...
                        </button>
                        <input
                          @change="inputFilesChanged"
                          ref="file_input"
                          type="file"
                          multiple
                          style="display:none"
                        />

                        <button
                          class="btn primary mx-2"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Add Files
                          <i class="fas fa-caret-down ml-1" />
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" @click="$refs.file_input.click()">
                            <i class="fas fa-window"></i>
                            <label class="mb-0">From computer</label>
                          </a>
                          <a class="dropdown-item" @click="openGoogleDrive" v-if="!googleUser">
                            <i class="fab fa-google-drive"></i>
                            <label class="mb-0">From Google Drive...</label>
                          </a>
                          <a class="dropdown-item" @click="openGoogleDrive" v-if="googleUser">
                            <i class="fab fa-google-drive"></i>
                            <label class="mb-0">From {{ googleUser.getName() }}'s Google Drive</label>
                          </a>
                          <a class="dropdown-item" @click="changeUser" v-if="googleUser">
                            <label class="mb-0 ml-4">Change user...</label>
                          </a>
                        </div>
                      </div>
                      <div class="box-body">
                        <p class="m-0">
                          These are the files you have associated with the students. Hover
                          over files to see which students they belong to.
                        </p>
                      </div>
                    </div>

                    <google-drive-picker
                      v-if="gapi.auth2"
                      :visible="showPicker"
                      :gapi="gapi"
                      :refresh="refreshPicker"
                      :students="students"
                      :user="user"
                      @closed="closePicker"
                      @picked="pickedFiles"
                      @assign="assignFiles"
                    />
                  </div>
                  <!-- Upload Column -->
                  <!-- <div class="col col-sm-4 align-self-stretch">
										<div class="box m-0 h100">
											<div class="box-header">
												<h2>Upload</h2>
											</div>
											<div class="box-body">
												<p class="m-0">Drag files to the box or click it to select files.</p>
											</div>
										</div>
                  </div>-->
                </div>
                <div class="row">
                  <!-- Student Column -->
                  <div class="col col-sm-6 align-self-stretch scroll-y">
                    <div class="box m-0 h100 scroll">
                      <div class="box-body p-0">
                        <table class="table mb-0">
                          <template v-for="student in sortedStudents">
                            <tr
                              @drag="startStudentDrag(student)"
                              @drop="dropMediaOnStudent(student)"
                              @dragenter.prevent="highlightStudentDragging(student)"
                              @dragover="dragover($event, !student.isScored)"
                              @mouseenter.prevent="highlightStudent(student)"
                              @mouseleave.prevent="removeHighlights()"
                              :key="student.id"
                              :draggable="!student.isScored"
                              :class="{
																'table-primary': student.highlight,
																'b-b': !student.open
															}"
                              class="no-select"
                            >
                              <td class="m-auto px-1 drag-handle flex-fixed w-40 text-center">
                                <i
                                  v-if="student.isScored"
                                  class="fas fa-lock-alt text-muted"
                                  v-tippy
                                  title="Scored responses cannot be edited"
                                ></i>
                                <i v-if="!student.isScored" class="far fa-arrows-alt text-muted"></i>
                              </td>
                              <td>
                                <span v-tippy :title="student.email">
                                  {{ student.last_name }},
                                  {{ student.first_name }}
                                </span>
                              </td>
                              <td>
                                <span
                                  class="badge badge-pill text-sm"
                                  :class="{ primary: student.medias.length > 0 }"
                                >
                                  {{ student.medias.length }}
                                  <span
                                    v-if="student.medias.length == 1"
                                  >File</span>
                                  <span v-if="student.medias.length != 1">Files</span>
                                </span>
                              </td>
                              <td>
                                <div v-if="!student.isScored">
                                  <a
                                    @click="
																			setStudentForFilePicker(student);
																			$refs.file_input.click();
																		"
                                  >
                                    <i class="fa fa-lg fa-file-upload"></i>
                                  </a>
                                </div>
                              </td>
                              <td @click="toggleStudent(student)">
                                <i
                                  v-if="student.medias && student.medias.length > 0"
                                  class="far fa-chevron-left text-muted anim-rotate"
                                  :class="{ 'rotate-90': student.open }"
                                ></i>
                              </td>
                            </tr>
                            <tr
                              :key="student.id + 'a'"
                              v-if="student.open && student.medias.length"
                              class="no-select b-b"
                            >
                              <td colspan="4" class="p-custom pt-0 pb-1">
                                <ul>
                                  <li v-for="media in student.medias" :key="media.media.value">
                                    {{ media.media.label }}
                                    <i
                                      v-if="!student.isScored"
                                      v-tippy
                                      title="Delete"
                                      @click="
																				removeMedia(media.media.id, student.id)
																			"
                                      class="fas fa-trash float-right text-muted clickable"
                                    ></i>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </template>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!-- Media Column -->
                  <div class="col col-sm-6 align-self-stretch">
                    <div class="box m-0 h100 scroll">
                      <div class="h100 box-body d-flex flex-column p-0">
                        <table class="table mb-0">
                          <template v-for="media in medias">
                            <tr
                              @drag="startMediaDrag(media)"
                              @drop="dropStudentOnMedia(media)"
                              @dragenter.prevent="highlightMediaDragging(media)"
                              @dragover="dragover($event, true)"
                              @mouseenter.prevent="highlightMedia(media)"
                              @mouseleave.prevent="removeHighlights()"
                              :key="media.media.value"
                              :draggable="supportedMimeType(media)"
                              :class="{
																'table-primary': media.highlight,
																'b-b': !media.open
															}"
                              class="no-select"
                            >
                              <td class="m-auto px-1 drag-handle flex-fixed w-40">
                                <i
                                  v-if="supportedMimeType(media)"
                                  class="far fa-arrows-alt text-muted"
                                ></i>
                                <i
                                  v-if="!supportedMimeType(media)"
                                  class="far fa-exclamation-triangle text-muted"
                                  v-tippy
                                  title="Unsupported file type"
                                ></i>
                              </td>
                              <td>{{ media.media.label }}</td>
                              <td>
                                <span
                                  v-if="supportedMimeType(media)"
                                  class="badge badge-pill text-sm"
                                  :class="{ primary: media.student_ids.length }"
                                >{{ media.student_ids.length }}</span>
                              </td>
                              <td @click="toggleMedia(media)">
                                <i
                                  v-if="media.students && media.students.length > 0"
                                  class="far fa-chevron-left text-muted anim-rotate"
                                  :class="{ 'rotate-90': media.open }"
                                ></i>
                              </td>
                            </tr>
                            <tr
                              v-if="media.open"
                              :key="media.media.value + 'a'"
                              class="no-select b-b"
                            >
                              <td colspan="4" class="p-custom pt-0 pb-1">
                                <ul>
                                  <li v-for="student in media.students" :key="student.id">
                                    {{ student.first_name }} {{ student.last_name }}
                                    <i
                                      v-if="!student.isScored"
                                      v-tippy
                                      title="Delete"
                                      @click="
																				removeMedia(media.media.id, student.id)
																			"
                                      class="fas fa-trash float-right text-muted"
                                    ></i>
                                    <i
                                      v-if="student.isScored"
                                      v-tippy
                                      title="Scored responses cannot be edited"
                                      class="fas fa-lock-alt float-right text-muted"
                                    ></i>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </template>

                          <!-- Google integration mockup -->
                          <tr v-for="file in googleFiles" :key="file.id" draggable="true">
                            <td class="m-auto px-1 drag-handle flex-fixed w-40">
                              <i class="far fa-arrows-alt text-muted"></i>
                            </td>
                            <td>{{ file.name }}</td>
                            <td>
                              <span class="badge badge-pill text-sm">0</span>
                            </td>
                            <td>
                              <i class="far fa-chevron-left text-muted"></i>
                            </td>
                          </tr>
                          <!--===========================-->
                        </table>

                        <div class="flex"></div>
                      </div>
                    </div>
                  </div>
                  <!-- Upload Column -->
                  <!-- <div class="col col-sm-4 align-self-stretch">
										<div
											class="p-3 card h100"
											style="min-height: 10rem;"
											@dragover.prevent
											@drop.prevent="dropFiles"
										>
											<h3
												class="flex text-very-muted text-center mt-5"
											>Drag work here or click to select files...</h3>


										</div>
                  </div>-->
                </div>
                <div class="row"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :visible="saveOptModal" v-if="dirty">
      <template slot="modal-title">Would You Like to Save These Changes?</template>
      <div class="py-4">
        You have made changes to this class's work. Would you like to save these changes before you leave the
        page?
      </div>
      <template slot="modal-footer">
        <button class="btn primary btn-flat" @click="saveOptCancel">Cancel</button>
        <button class="btn danger btn-flat" @click="discardAndExit">Discard Changes</button>
        <button class="btn success btn-flat" @click="saveAndExit" v-if="!saving">Save</button>
        <button class="btn btn-secondary btn-flat" v-if="saving" disabled>
          Saving&nbsp;&nbsp;
          <loading type="icon" />
        </button>
      </template>
    </b-modal>

    <mzfooter></mzfooter>
  </div>
</template>

<style scoped>
.curved-br {
  border-bottom-right-radius: 0.75rem;
}
.section {
  max-width: 500px;
}
.section > .box-header {
  text-align: center;
  font-size: 28px;
}
.btn-icon.btn-sm {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
}
ul {
  margin-bottom: 0;
}
li {
  margin-top: 2px;
  margin-bottom: 2px;
  padding-right: 40px;
}
li i {
  line-height: 23px;
}
.clickable {
  transition: opacity 0.25s;
}
.clickable:hover {
  opacity: 1;
}
.anim-rotate {
  transition: transform 0.1s ease-out;
}
.rotate-90 {
  transform: rotate(-90deg);
}
.table td {
  border: none;
}
.scroll {
  height: 60vh;
  overflow: scroll;
  overflow-x: hidden;
}
</style>

<script>

import GoogleDrivePicker from "@/components/GoogleDrivePicker";
import ResponseMediaService from "@/services/ResponseMediaService";
import AssessmentService from "@/services/AssessmentService";
import ClassService from "@/services/ClassService";
import StudentService from "@/services/StudentService";
import GDriveService from "@/services/GDriveService";
import Notie from "@/services/NotieService";
import BB from "bluebird";
import $ from "jquery";
import BMF from "browser-md5-file";

import SaveOptionalModal from "@/components/SaveOptionalModal";
import GoogleApiRequest from "@/components/GoogleApiRequest";

var unsupportedMTs = {
  "application/msword": true,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
  "application/vnd.ms-excel": true,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
  "application/vnd.ms-powerpoint": true,
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
  "text/csv": true
};

var unsupportedExts = {
  doc: true,
  docx: true,
  xls: true,
  xlsx: true,
  ppt: true,
  pptx: true,
  csv: true
};

export default {
  name: "DeliveryResponses",

  props: ["user"],

  data() {
    return {
      dirty: false,
      clazz: null,
      assessment: null,
      delivery: null,

      items: null,
      students: [],
      medias: [],
      newWork: [],

      classID: this.$route.params.classID,
      deliveryID: this.$route.params.deliveryID,
      assessmentID: this.$route.params.asmtID,

      selectedItem: null,

      studentMedia: [],

      newFiles: [],

      draggingEntity: null,

      loading: true,
      bmf: new BMF(),
      saving: false,

      totalFiles: 0,
      completeFiles: 0,

      googleFiles: [],

      inputFiles: [],

      saveOptModal: false,
      saveOptNext: () => {},
      saveOptCancel: () => {},

      studentForFilePicker: null,

      gapi: gapi,
      googleAuth: null,
      googleUser: null,
      isSignedIn: null,
      showPicker: null,
      refreshPicker: null,

      individualWorkUploadLoop: null
    };
  },

  components: { GoogleDrivePicker, SaveOptionalModal },

  created() {
    this.loadData();

    this.connectGoogleDrive();
  },

  watch: {
    individualWorkUploadLoop() {
      if (this.individualWorkUploadLoop === 0) {
        this.studentForFilePicker = null;
      }
    }
  },

  computed: {
    sortedStudents() {
      return _.orderBy(
        this.students,
        ["last_name", "first_name"],
        ["asc", "asc"]
      );
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.dirty) {
      this.saveOptNext = () => {
        next();
      };
      this.saveOptCancel = () => {
        next(false);
        this.saveOptModal = false;
      };
      this.saveOptModal = true;
    } else {
      next();
    }
  },

  methods: {
    loadData() {
      return BB.props({
        class: ClassService.getClass(this.classID, true),
        assessment: AssessmentService.getAssessment(this.assessmentID),
        work: AssessmentService.getClassAssessmentWork(
          this.classID,
          this.assessmentID
        )
      })
        .then(resps => {
          this.clazz = resps.class.data;
          this.assessment = resps.assessment.data;
          this.delivery = _.find(this.clazz.deliveries, {
            id: this.deliveryID
          });
          this.items = _.map(this.assessment.item, "item");
          // debugger;
          this.selectedItem = this.items;

          this.students = [];
          _.each(resps.work.data.stats, stat => {
            let student = stat.student;
            student.medias = [];
            _.each(stat.responses, r => {
              if (r.delivery_id == this.deliveryID && r.scores.length > 0) {
                student.isScored = true;
              }
            });
            this.students.push(student);
          });
          this.students = _.orderBy(
            this.students,
            ["student.last_name", "student.first_name"],
            ["asc", "asc"]
          );

          // debugger;

          ResponseMediaService.getMedia(
            this.clazz.id,
            this.assessment.id,
            this.delivery.id,
            this.assessment.id
          ).then(resp => {
            // debugger;
            console.log("here we go", resp.data);
            this.medias = resp.data;
            this.updateStudentMedias();
          });

          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to load classes", err);
        });
    },
    //File drop events
    dropFiles(ev) {
      //Known issue -- if you add the same exact file with different file names or from a different source file
      //they will not get ignored and you will get strange results when grouping media by hash. We need to
      //eventually do the md5 synchronously and then only add new files if they are unique.
      _.each(ev.dataTransfer.files, f => {
        this.addNewWork(f);
      });
    },
    inputFilesChanged() {
      if (!this.studentForFilePicker) {
        var input = this.$refs.file_input;
        _.each(input.files, f => {
          this.addNewWork(f);
        });
      } else {
        var input = this.$refs.file_input;
        this.individualWorkUploadLoop = input.files.length;
        _.each(input.files, f => {
          this.addNewWorkForStudent(f, media => {
            this.startMediaDrag(media);
            this.dropMediaOnStudent(this.studentForFilePicker);
            if (
              media.media.label.trim().localeCompare("image") === 0 &&
              this.studentForFilePicker != null
            ) {
              media.media.label = "Image of "
                .concat(this.studentForFilePicker.full_name)
                .concat("'s work");
            }
            this.individualWorkUploadLoop--;
          });
        });
      }
    },
    addNewWork(file) {
      var suggestedName = file.name.split(".");
      var extension = null;
      if (suggestedName.length > 1) {
        //Pop off the extension if it exists
        extension = suggestedName.pop();
      }
      suggestedName = suggestedName.join("");
      suggestedName = suggestedName.replace(/_/g, " ");

      if (file.fromGDrive) {
        var existing = _.find(this.medias, m => {
          return m.media && m.media.id == file.id;
        });
        if (!existing) {
          this.medias.push({
            new: true,
            student_ids: [],
            media: {
              label: suggestedName,
              extension: extension,
              id: file.id,
              file: file,
              uploading: false
            }
          });
        }
      } else {
        this.bmf.md5(
          file,
          (err, md5) => {
            //Check if any of the existing files match this md5
            var existing = _.find(this.medias, m => {
              return m.media && m.media.id == md5;
            });
            console.log(md5);
            if (!existing) {
              this.medias.push({
                new: true,
                student_ids: [],
                media: {
                  label: suggestedName,
                  extension: extension,
                  id: md5,
                  file: file,
                  uploading: false
                }
              });
            }
          },
          () => {}
        );
      }
    },

    addNewWorkForStudent(file, callback) {
      var suggestedName = file.name.split(".");
      var extension = null;
      if (suggestedName.length > 1) {
        //Pop off the extension if it exists
        extension = suggestedName.pop();
      }
      suggestedName = suggestedName.join("");
      suggestedName = suggestedName.replace(/_/g, " ");

      if (file.fromGDrive) {
        var existing = _.find(this.medias, m => {
          return m.media && m.media.id == file.id;
        });
        if (!existing) {
          this.medias.push({
            new: true,
            student_ids: [],
            media: {
              label: suggestedName,
              extension: extension,
              id: file.id,
              file: file,
              uploading: false
            }
          });
        }
      } else {
        this.bmf.md5(
          file,
          (err, md5) => {
            //Check if any of the existing files match this md5
            var existing = _.find(this.medias, m => {
              return m.media && m.media.id == md5;
            });
            console.log(md5);
            if (!existing) {
              this.medias.push({
                new: true,
                student_ids: [],
                media: {
                  label: suggestedName,
                  extension: extension,
                  id: md5,
                  file: file,
                  uploading: false
                }
              });
              callback(this.medias[this.medias.length - 1]);
            } else {
              callback(existing);
            }
          },
          () => {}
        );
      }
    },

    //Our drop events
    dropMediaOnStudent(student) {
      if (this.draggingEntity.media) {
        this.addIfNotExists(this.draggingEntity.value, student.id);
      }
      this.draggingEntity = null;
      this.updateStudentMedias();
      console.log("Dropped media");
    },
    dropStudentOnMedia(media) {
      if (this.draggingEntity.student && this.supportedMimeType(media)) {
        this.addIfNotExists(media, this.draggingEntity.value.id);
      }
      this.draggingEntity = null;
      this.updateStudentMedias();
    },
    dragover(e, selectable) {
      if (selectable) {
        e.preventDefault();
      }
    },
    startStudentDrag(student) {
      this.draggingEntity = {
        student: true,
        value: student
      };
    },
    startMediaDrag(media) {
      this.draggingEntity = {
        media: true,
        value: media
      };
    },
    getStudentMedia(student) {
      var media = [];
      _.each(this.medias, m => {
        if (_.includes(m.student_ids, student.id)) {
          media.push(m);
        }
      });
      return media;
    },
    addIfNotExists(media, student_id) {
      if (!_.includes(media.student_ids, student_id)) {
        this.dirty = true;
        media.student_ids.push(student_id);
      }
    },

    updateStudentMedias() {
      //Place media objects inside the student records
      _.each(this.students, s => {
        var temp_medias = s.medias;
        s.medias = [];

        //keeping old media in
        _.each(temp_medias, m => {

           if (_.includes(m.student_ids, s.id)) {
                s.medias.push(m);
            }
        });
        
        //adding new media
        _.each(this.medias, m => {
          var index = s.medias.findIndex(x => x.media.id == m.media.id);

          if (index === -1) {
            if (_.includes(m.student_ids, s.id)) {

              s.medias.push(m);
            }
          } else {
            console.log("object already exists");
          }

        });
      });

      _.each(this.medias, m => {
        m.students = [];

        _.each(this.students, s => {
          if (_.includes(m.student_ids, s.id)) {
            m.students.push(s);
          }
        });
      });
    },

    removeMedia(mediaID, studentID) {
      _.each(this.medias, m => {
        if (m.media.id == mediaID) {
          m.student_ids = _.without(m.student_ids, studentID);
        }
      });
      this.dirty = true;
      this.updateStudentMedias();
      this.$forceUpdate();
    },

    //Highlighting
    highlightStudent(student) {
      student.highlight = true;
      _.each(this.medias, m => {
        if (_.includes(m.student_ids, student.id)) {
          m.highlight = true;
        }
      });
      this.$forceUpdate();
    },
    highlightMedia(media) {
      media.highlight = true;
      _.each(this.students, s => {
        if (_.includes(media.student_ids, s.id)) {
          s.highlight = true;
        }
      });
      this.$forceUpdate();
    },
    highlightStudentDragging(student) {
      if (this.draggingEntity.student) {
        //Dragged student onto student, only highlight the original
        this.draggingEntity.value.highlight = true;
      } else {
        _.each(this.students, s => {
          s.highlight = false;
        });
        _.each(this.medias, m => {
          m.highlight = false;
        });

        //Dragged media onto student
        let media = this.draggingEntity.value;
        //Highlight the dragged media
        this.draggingEntity.value.highlight = true;
        _.each(this.students, s => {
          //Highlight any students that already have that media
          if (_.includes(media.student_ids, s.id)) {
            s.highlight = true;
          }
          //And the target student, if it's a valid target (not scored)
          if (s.id == student.id && !student.isScored) {
            s.highlight = true;
          }
        });
      }
      this.$forceUpdate();
    },
    highlightMediaDragging(media) {
      if (this.draggingEntity.media) {
        //Dragged media onto media, only highlight the original
        this.draggingEntity.value.highlight = true;
      } else {
        _.each(this.students, s => {
          s.highlight = false;
        });
        _.each(this.medias, m => {
          m.highlight = false;
        });

        //Dragged student onto media
        let student = this.draggingEntity.value;
        //Highlight the dragged student
        this.draggingEntity.value.highlight = true;
        _.each(this.medias, m => {
          //Highlight any medias that already have that media
          if (_.includes(m.student_ids, student.id)) {
            m.highlight = true;
          }
          //And the target student
          if (m.media.id == media.media.id) {
            m.highlight = true;
          }
        });
      }
      this.$forceUpdate();
    },

    removeHighlights() {
      _.each(this.students, s => {
        s.highlight = false;
      });
      _.each(this.medias, m => {
        m.highlight = false;
      });
      this.$forceUpdate();
    },

    //Toggle preview
    toggleMedia(media) {
      var state = media.open;
      _.each(this.medias, m => {
        m.open = false;
      });
      media.open = !state;
      this.$forceUpdate();
    },
    toggleStudent(student) {
      var state = student.open;
      _.each(this.students, s => {
        s.open = false;
      });
      student.open = !state;
      this.$forceUpdate();
    },

    //Persisting
    save() {

      if (this.saving) {
        return;
      }
      this.saving = true;
      var promiseCalls = [];
      let cid = this.classID;
      let aid = this.assessmentID;
      let did = this.deliveryID;
      let iid = this.assessment.id;

      this.totalFiles = 0;
      this.completeFiles = 1;

      var existingMedia = [];
      //First save new media.
      _.each(this.medias, m => {
        // debugger;
        if (m.new) {
                console.log("NEW MEDIA IS ADDED ====== ")
          if (m.student_ids.length) {
            if (m.media.file.fromGDrive) {
              let call = () => {
                return ResponseMediaService.addGDriveMedia(
                  cid,
                  aid,
                  did,
                  iid,
                  gapi,
                  m.media.file,
                  m.student_ids
                ).catch(err => {
                  console.log(err);
                  Notie.error("Failed to save file", m.media.label);
                });
              };
              promiseCalls.push(call);
              this.totalFiles++;
            } else {

              let form = new FormData();
              form.set("file", m.media.file);
              form.set("name", m.media.label);
              form.set("sids", JSON.stringify(m.student_ids));
              let call = () => {
                return ResponseMediaService.addMedia(
                  cid,
                  aid,
                  did,
                  iid,
                  form
                ).catch(err => {
                  console.log(err);
                  Notie.error("Failed to save file", m.media.label);
                });
              };
              promiseCalls.push(call);
              this.totalFiles++;
            }
          }
        } else {
          existingMedia.push(m);
        }
      });

      _.each(existingMedia, m => {
        m.students = null;
      });

      BB.map(
        promiseCalls,
        call => {
          return call().then(() => {
            this.completeFiles++;
          });
        },
        { concurrency: 3 }
      ).then(() => {
              console.log("promis call ",promiseCalls)
        //Then push array of existing media to update
        var data = {
                students:this.pullMediasOut(this.students),
                medias:        existingMedia
        } 
        ResponseMediaService.updateMedia(
          data,
          this.classID,
          this.assessmentID,
          this.deliveryID,
          this.assessment.id
        ).then(() => {
          this.saving = false;
          this.dirty = false;
          this.loadData();
        });
      });
    },

    saveAndExit() {
      this.save()
        .then(resp => {
          this.saveOptNext();
        })
        .catch(err => {});
    },

    discardAndExit() {
      this.saveOptNext();
    },
    pullMediasOut(students){
            
            for (let index = 0; index < students.length; index++) {
                    students[index].medias = students[index].medias.map(x => x.media);
                    
            }
            console.log("new students ",students)
            return students
    },
    connectGoogleDrive(doSignIn, doOpen) {
      let clientId =
        "858905472313-fo0bitsgfq8umudeq25c8jro3f8h06p2.apps.googleusercontent.com";
      let apiKey = "AIzaSyAz1yrFwxIoZCdRVPCjzs5U-KYYIwtBIxE";

      if (!this.googleAuth) {
        gapi.load("client", () => {
          gapi.client
            .init({
              apiKey: apiKey,
              clientId: clientId,
              scope: "https://www.googleapis.com/auth/drive.readonly",
              discoveryDocs: [
                "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
              ]
            })
            .then(resp => {
              if (!this.googleAuth) {
                this.googleAuth = gapi.auth2.getAuthInstance();
                this.googleAuth.isSignedIn.listen(() => {
                  this.isSignedIn = this.googleAuth.isSignedIn.get();
                  if (this.isSignedIn) {
                    this.googleUser = this.googleAuth.currentUser
                      .get()
                      .getBasicProfile();
                    this.openGooglePicker();
                  } else {
                    this.googleAuth = null;
                    this.googleUser = null;
                    this.isSignedIn = null;
                    this.connectGoogleDrive(true, true);
                  }
                });
              }

              this.isSignedIn = this.googleAuth.isSignedIn.get();

              if (this.isSignedIn) {
                this.googleUser = this.googleAuth.currentUser
                  .get()
                  .getBasicProfile();
              }

              if (this.isSignedIn && doOpen) {
                if (doOpen) {
                  this.openGooglePicker();
                }
              } else {
                if (doSignIn) {
                  gapi.auth2.getAuthInstance().signIn();
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      } else {
        this.googleUser = this.googleAuth.currentUser.get().getBasicProfile();
        if (this.isSignedIn && doOpen) {
          if (doOpen) {
            this.openGooglePicker();
          }
        } else {
          if (doSignIn) {
            this.googleAuth.signIn();
          }
        }
      }
    },

    changeUser() {
      this.googleAuth.disconnect();
    },

    openGoogleDrive() {
      if (!this.isSignedIn) {
        this.connectGoogleDrive(true, true);
      } else {
        this.openGooglePicker();
      }
    },

    openGooglePicker() {
      this.showPicker = true;
      this.refreshPicker = new Date();
      this.$forceUpdate();
    },

    closePicker() {
      this.showPicker = false;
    },

    pickedFiles(files) {
      _.each(files, file => {
        file.fromGDrive = true;
        this.addNewWork(file);
      });
      this.showPicker = false;
    },

    assignFiles(files) {
      let assigned = [];
      _.each(files, file => {
        if (file.matchedStudent) {
          let media = false;
          _.each(this.medias, m => {
            if (m.media && m.media.id == file.id) {
              media = m;
            }
          });
          if (media) {
            this.addIfNotExists(media, file.matchedStudent.id);
            assigned.push(
              `<li>Assigned "<strong>${media.media.label}</strong>" to "<strong>${file.matchedStudent.full_name}</strong>"</li>`
            );
          }
        }
      });
      this.updateStudentMedias();
      Notie.success(
        `<ul style="padding-inline-start: 20px; margin-bottom: 0;">` +
          assigned.join("") +
          "</ul>"
      );
    },

    supportedMimeType(media) {
      let m = media.media;
      if (!m) {
        return true;
      }

      if (m.mime_type) {
        if (unsupportedMTs[m.mime_type]) {
          return false;
        } else {
          return true;
        }
      } else if (m.extension) {
        if (unsupportedExts[m.extension]) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    setStudentForFilePicker(student) {
      this.studentForFilePicker = student;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/vues/Classes/DeliveryResponses.vue